
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/helping-companies",
      function () {
        return require("private-next-pages/helping-companies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/helping-companies"])
      });
    }
  